import { EVENT_ACTIONS } from '../actions';
import { cloneDeep } from 'lodash';
import { IEventsDefAndSelectedState } from '../../Interfaces/index';
import { Map as immutableMAP } from 'immutable';
import { IgenomicsAction } from '@ispm/core/interfaces/genomics-action.interface';
import * as immutable from 'immutable';


const initEventsDefState: IEventsDefAndSelectedState = {
    eventsDefinition: immutableMAP(),
    selectedEvent: null,
    eventsData: immutable.Map(),
    timelineSelectedEvent: null,
    discardEventTabData: false,
    viewWizard: false
  }
;

export function eventsReducer(state: IEventsDefAndSelectedState = initEventsDefState,
                              action: IgenomicsAction<any>): IEventsDefAndSelectedState {
  switch (action.type) {
    case EVENT_ACTIONS.ADD_EVENTS_DEFINITION:
      // state.eventsDefinition = action.payload.upsert(state.eventsDefinition);
      return Object.assign({ }, state, { eventsDefinition: action.payload});
    case EVENT_ACTIONS.CHANGE_SELECTED_EVENT:
      // state.selectedEvent = action.payload.upsert(state.selectedEvent);
      return Object.assign({ }, state, { selectedEvent: action.payload});
    case EVENT_ACTIONS.ADD_EVENTS:
      // state.selectedEvent = action.payload.upsert(state.selectedEvent);
      return Object.assign({ }, state, { eventsData: action.payload});
    case EVENT_ACTIONS.UPDATE_EVENT:
      // state.selectedEvent = action.payload.upsert(state.selectedEvent);
      const newState = cloneDeep(state);
      newState.eventsData = newState.eventsData.set(action.payload.id, action.payload.data);
      return newState;
    case EVENT_ACTIONS.CLEAR_EVENTS:
      return Object.assign({ }, state, { eventsData: immutable.Map()});
    case EVENT_ACTIONS.CHANGE_TIMELINE_SELECTED_EVENT:
      // state.selectedEvent = action.payload.upsert(state.selectedEvent);
      return Object.assign({ }, state, { timelineSelectedEvent: action.payload});
    case EVENT_ACTIONS.DISCARD_EVENT_TAB_DATA:
      // state.selectedEvent = action.payload.upsert(state.selectedEvent);
      return Object.assign({ }, state, { discardEventTabData: action.payload});
    case EVENT_ACTIONS.ADD_VIEW_WIZARD:
      return Object.assign({},state,{viewWizard:action.payload});
      default:
      return state;
  }
}
